import "styles/pages/page-repurchase.scss";
import React, { useState } from "react";

import Layout from "components/Layout";
import ScrollTile from "components/ScrollTile/ScrollTile";
import SectionHeader from "components/SectionHeader/SectionHeader";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader/SubpageHeader";
import TeamPersonTile from "components/TeamPersonTile/TeamPersonTile";
import ContactForm from "../components/ContactForm/ContactForm";

const RepurchasePage = ({ pageContext }) => {
	const pageContent = pageContext.pageContent;
	const seo = pageContext.seo;
	const team = pageContext.pageContent.sellTeam;
	const [recipient, setRecipient] = useState("");
	const onReset = () => {
		setRecipient("");
	};
	return (
		<Layout>
			<Seo title={seo.title} description={seo.metaDesc} />
			<SubpageHeader
				title={pageContent.mainTitle}
				subtitle={pageContent.subtitle}
				crumbFirstLabel="pojazdy kempingowe"
				crumbFirstLink="/nowe-kampery-i-nowe-przyczepy-campingowe/"
				location={pageContent.mainTitle}
			/>
			<section className="suspensions-about">
				<div className="container">
					<div
						className="suspensions-about__text"
						dangerouslySetInnerHTML={{ __html: pageContent.desc }}
					/>
					<div className="row justify-content-center">
						<div className="col-xl-4 col-sm-6">
							<ScrollTile
								title="Udzielimy informacji i doradzimy najlepsze rozwiązania!"
								icon={
									require("assets/icons/team-support.svg")
										.default
								}
								anchor="kontakt"
								buttonText="Skontaktuj się z działem zawieszeń"
								shadow={false}
								contact={true}
							/>
						</div>
					</div>
				</div>
			</section>
			<span className="anchor" id="kontakt"></span>
			<section className="suspensions-team">
				<div className="container">
					<SectionHeader
						title="Dział sprzedaży pojazdów kempingowych"
						subtitle="NASZ ZESPÓŁ"
						reversed={true}
					/>
					<div className="row justify-content-center">
						{team?.map((person, index) => {
							return (
								<div
									className="col-xl-3 col-md-4 col-sm-6"
									key={index}
								>
									<TeamPersonTile
										name={person.singleTeam.fullname}
										jobName={person.singleTeam.jobname}
										avatar={
											person.singleTeam.avatar?.sourceUrl
										}
										phone={person.singleTeam.phone}
										email={person.singleTeam.email}
										onClick={(e) =>
											setRecipient(
												person.singleTeam.email
											)
										}
									/>
								</div>
							);
						})}
					</div>
				</div>
			</section>
			<span className="anchor" id="formularz"></span>
			<section className="suspensions-contact">
				<ContactForm
					subject="ODKUP POJAZDÓW"
					selectedEmail={recipient}
					onReset={onReset}
				/>
			</section>
		</Layout>
	);
};

export default RepurchasePage;
